var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ylInvestSystem"}},[(_vm.isMobileScreen)?_c('ylInvestSystemMobile',_vm._b({attrs:{"list":_vm.list}},'ylInvestSystemMobile',_vm.$attrs,false)):_c('ylInvestSystemPC',_vm._b({attrs:{"list":_vm.list}},'ylInvestSystemPC',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }